import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { SearchTextFieldStyles } from "@insite/content-library/Widgets/OrderHistory/SearchTextField";
import DiscrepancySearchField from "@tKgpco/Widgets/DiscrepancyHistory/DiscrepancySearchField";
import * as React from "react";

export const poNumberStyles: SearchTextFieldStyles = {};
const styles = poNumberStyles;

const DiscrepancySearchFieldPoNumber: React.FunctionComponent<WidgetProps> = () => {
    return (
        <DiscrepancySearchField
            styles={styles}
            parameterField="poNumber"
            label="PO #"
            inputType="text"
            placeholder=""
            testSelector="discrepancy_filterPONumber"
        />
    );
};

const widgetModule: WidgetModule = {
    component: DiscrepancySearchFieldPoNumber,
    definition: {
        group: "Common",
        displayName: "Discrepancy PO Number",
    },
};

export default widgetModule;
